import Home from "../../Components/Server/Home";
const HomePage=()=>{

    return <>
    <Home />
    </>
}

export default HomePage;